import { useStaticQuery, graphql } from 'gatsby'

export function useDataVideos() {
    const data = useStaticQuery(graphql`
        {
            videos: allDatoCmsRenshinTeamVideo(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    id
                    title
                    text
                    videoUrl
                    sorting
                    poster {
                        url
                    }
                }
            }
        }
    `)

    return data.videos.nodes
}
